import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventAttendeeTicketOrder } from '@models/events/event-attendee-ticket-order.model';
import { Event } from '@models/events/event.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ticket-order-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ticket-order-card.component.html',
  styleUrl: './ticket-order-card.component.scss',
})
export class TicketOrderCardComponent {
  @Input() event?: Event;
  @Input() order!: EventAttendeeTicketOrder;
  @Input() headerView = false;

  @Output() selectOrder = new EventEmitter<EventAttendeeTicketOrder>();

  currentLang?: string;

  constructor(private translateService: TranslateService) {
    this.translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.currentLang = this.translateService.currentLang;
      });
    this.currentLang = this.translateService.currentLang;
  }

  onSelectOrder() {
    if (this.headerView) {
      return;
    }

    this.selectOrder.emit(this.order);
  }
}
